import React, { useState } from "react"
import { useStaticQuery, graphql } from "gatsby"
import PropTypes from "prop-types"
import { Link } from "gatsby"
import styled from "styled-components"
import logo from "../images/logo.png"

const Header = ({ siteTitle }) => {
  const [isExpanded, toggleExpansion] = useState(false)
  const [isExpandedMenu, toggleExpansionMenu] = useState(false)
  const data = useStaticQuery(graphql`
    {
      sanityNavigation {
        menu {
          active
          title
          category {
            color
            title
            slug {
              current
            }
          }
        }
      }
    }
  `)
  var themeBgColor = "text-fb-blue"
  var themeBgColorHover = "hover:text-fb-blue"

  // var themeTextColor = "text-fb-blue"

  return (
    <>
      <UpperLine />
      {/* <SecondUpperLine /> */}
      <header className="relative max-w-screen mx-auto">
        <MainHeader>
          <div className="max-w-screen-xl mx-auto flex flex-wrap justify-between items-center p-5">
            <div className="flex flex-wrap justify-between items-center">
              <Link to="/">
                <img
                  src={logo}
                  alt="Персональные финансы"
                  width="80"
                  height="80"
                />
              </Link>
              <Link to="/" className="text-gray-200">
                <p className="font-opensanscond text-2xl md:text-5xl pl-5">
                  {siteTitle}
                </p>
              </Link>
            </div>
            <div className="flex xl:hidden">
              <button
                type="button"
                aria-label="mobile-menu"
                onClick={() => toggleExpansion(!isExpanded)}
                className={`${
                  isExpanded ? `is-active` : `none`
                } hamburger hamburger--squeeze outline-none`}
              >
                <span className="hamburger-box">
                  <span className="hamburger-inner"></span>
                </span>
              </button>
            </div>
          </div>
        </MainHeader>
      </header>
      <Navbar
        className={`${
          isExpandedMenu ? `rounded-none` : `rounded-none xl:rounded-b`
        } hidden xl:flex justify-between items-center max-w-screen-xl mx-auto sticky top-0 border-b-4 border-fb-blue divide-x divide-gray-400`}
      >
        <Link
          to="/"
          className="navbarbtn hover:bg-fb-blue hover:text-gray-300"
          activeClassName="bg-fb-blue activeLink"
        >
          Новости
        </Link>
        {data.sanityNavigation.menu.map((item, index) => {
          switch (item.category.color) {
            case "fb-green": {
              themeBgColor = "bg-fb-green"
              themeBgColorHover = "hover:bg-fb-green"
              break
            }
            case "fb-turquoise": {
              themeBgColor = "bg-fb-turquoise"
              themeBgColorHover = "hover:bg-fb-turquoise"
              break
            }
            case "fb-gray": {
              themeBgColor = "bg-fb-gray"
              themeBgColorHover = "hover:bg-fb-gray"
              break
            }
            case "fb-red": {
              themeBgColor = "bg-fb-red"
              themeBgColorHover = "hover:bg-fb-red"
              break
            }
            case "fb-violet": {
              themeBgColor = "bg-fb-violet"
              themeBgColorHover = "hover:bg-fb-violet"
              break
            }
            default: {
              themeBgColor = "bg-fb-blue"
              themeBgColorHover = "hover:bg-fb-blue"
              break
            }
          }
          return (
            item.category.slug && (
              <Link
                key={index}
                activeClassName={`${themeBgColor} activeLink`}
                to={`/${item.category?.slug?.current}`}
                className={`${
                  item.active
                    ? `visible navbarbtn ${themeBgColorHover} hover:text-gray-300`
                    : `hidden`
                }`}
              >
                {item.title}
              </Link>
            )
          )
        })}
        <Link
          to="/kontakty"
          activeClassName="bg-fb-blue activeLink"
          className="navbarbtn hover:bg-fb-blue hover:text-gray-300"
        >
          Контакты
        </Link>
        <a
          href="https://t.me/FinanzasDeBolsillo"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="telegram"
          className="navbarbtn bg-yellow-300 hover:bg-yellow-400 hover:text-gray-600"
        >
          Telegram
        </a>
        <button
          onClick={() => toggleExpansionMenu(!isExpandedMenu)}
          className="navbarbtn hover:bg-fb-blue hover:text-gray-300"
        >
          Меню
        </button>
      </Navbar>
      <div
        className={`${
          isExpandedMenu
            ? `hidden xl:grid h-80 transition duration-500 ease-in-out`
            : `hidden h-0`
        } rounded-b max-w-screen-xl mx-auto border-b-4 border-fb-blue bg-fb-blue`}
      >
        <div className="flex justify-between max-w-screen-xl text-white text-3xl p-10">
          Veniam in nostrud aliquip pariatur velit. Sit elit magna qui deserunt.
          Reprehenderit nostrud amet sunt officia ut non do cupidatat. Cillum et
          non eu ut non nostrud pariatur. Id aliqua laborum excepteur occaecat
          aute sint. Excepteur esse aliquip anim consectetur commodo est fugiat
          elit reprehenderit velit labore.
        </div>
      </div>

      <NavbarMobile
        className={`${
          isExpanded
            ? `grid h-full transition duration-500 ease-in-out`
            : `hidden h-0`
        } items-center divide-y divide-gray-400 px-5`}
      >
        <Link to="/" className="navbarbtnmobile">
          Новости
        </Link>
        {data.sanityNavigation.menu.map((item, index) => {
          return (
            item.category.slug && (
              <Link
                key={index}
                to={`/${item.category?.slug?.current}`}
                className={`${
                  item.active ? `visible navbarbtnmobile` : `hidden`
                }`}
              >
                {item.title}
              </Link>
            )
          )
        })}
        <Link to="/kontakty" className="navbarbtnmobile">
          Контакты
        </Link>
        <a
          href="https://t.me/FinanzasDeBolsillo"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="telegram"
          className="navbarbtnmobile bg-yellow-300"
        >
          Telegram
        </a>
      </NavbarMobile>
    </>
  )
}

Header.propTypes = {
  siteTitle: PropTypes.string,
}

Header.defaultProps = {
  siteTitle: ``,
}
const UpperLine = styled.div`
  position: absolute;
  height: 5px;
  width: 100%;
  background-color: black;
`
const Navbar = styled.nav`
  height: 50px;
  background-color: #d1dae8;
  z-index: 100;
`
const NavbarMobile = styled.nav`
  background-color: #d1dae8;
  z-index: 100;
`
const MainHeader = styled.div`
  /* height: 140px; */
  height: 120px;
  background: rgb(16, 25, 45);
  background: -moz-linear-gradient(
    180deg,
    rgba(16, 25, 45, 1) 0%,
    rgba(35, 81, 160, 1) 100%
  );
  background: -webkit-linear-gradient(
    180deg,
    rgba(16, 25, 45, 1) 0%,
    rgba(35, 81, 160, 1) 100%
  );
  background: linear-gradient(
    180deg,
    rgba(16, 25, 45, 1) 0%,
    rgba(35, 81, 160, 1) 100%
  );
  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr="#10192d",endColorstr="#2351a0",GradientType=1);
`
export default Header
